<!--  -->
<template>
  <div ref="userCard">
    <div class="box tr_title">
      <div class="box_f1">
        <span :class="icon" class="iconfont"></span>
        {{title}}
      </div>
      <div class="icontext pointer" @click="downloadFile()">
        <span class="iconfont icon-daochu icon"></span>
        <span>导出</span>
      </div>
    </div>
    <div class="box tr_select">
      <div class="box shrink">
        <Dropdown trigger="click">
          <div class="pointer box" @click="dropDownOpen(0)">
            <div class="slh" style="max-width: 90px" :title="showname[0]">{{showname[0]}}</div>
            <div class="icon iconfont icon-xiala1 icondown" :class="{iconup:isOpen[0]}"></div>
          </div>
          <DropdownMenu slot="list" class="DropdownMenulist" @click.stop="switchNav">
            <DropdownItem
              class="dropdownitem minWidth"
              v-for="(item,index) in orglist"
              :key="index"
              :data-index="index"
              :class="{itemselect:index==showIndex[0]}"
            >
              <div class="box borderBottom" @click="dropItemClick(0,index)">
                <div class="box_f1">{{item.communityName}}</div>
                <div class="box iconfont icon-duigou select" v-if="index==showIndex[0]"></div>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div style="margin:0 20px" class="shrink">
        <DatePicker
          type="daterange"
          split-panels
          :open="isOpen[1]"
          confirm
          @on-change="dateChange"
          @on-ok="dateOk"
          @on-clear="dateInit"
          placement="bottom"
        >
          <!-- 时间选择 -->
          <div class="date-range pointer box" @click="dropDownOpen(1)">
            {{dateRange}}
            <div class="icon iconfont icon-xiala1 icondown" :class="{iconup:isOpen[1]}"></div>
          </div>
        </DatePicker>
      </div>
      <div class="box shrink" v-if="countType == 'score'">
        <Dropdown trigger="click">
          <div class="pointer box" @click="clickDrop">
            {{sourceName}}
            <div class="icon iconfont icon-xiala1 icondown" :class="{iconup:isSOpen}"></div>
          </div>
          <DropdownMenu slot="list" class="DropdownMenulist">
            <DropdownItem
              class="dropdownitem"
              v-for="(item,index) in sourceType"
              :key="item.id"
              :data-index="index"
              :class="{itemselect:index==showSIndex}"
            >
              <div class="box borderBottom" @click="dropItemClickS(index)">
                <div class="box_f1">{{item.label}}</div>
                <div class="box iconfont icon-duigou select" v-if="index==showSIndex"></div>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="box shrink">
        <Dropdown trigger="click">
          <div class="pointer box" @click="dropDownOpen(2)">
            {{showname[2]}}
            <div class="icon iconfont icon-xiala1 icondown" :class="{iconup:isOpen[2]}"></div>
          </div>
          <DropdownMenu slot="list" class="DropdownMenulist">
            <DropdownItem
              class="dropdownitem"
              v-for="(item,index) in usertype"
              :key="item.id"
              :data-index="index"
              :class="{itemselect:index==showIndex[2]}"
            >
              <div class="box borderBottom" @click="dropItemClick(2,index)">
                <div class="box_f1">{{item.label}}</div>
                <div class="box iconfont icon-duigou select" v-if="index==showIndex[2]"></div>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <Table
      :columns="columnsTitle"
      :data="tableData"
      disabled-hover
      stripe
      :border="false"
      @on-filter-change="filterChange"
      :height="height"
    >
      <div slot="footer" class="footer">
        <page :total="total" show-total @on-change="clickPage" :current.sync="current"/>
      </div>
    </Table>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      title: String,
      columnsTitle: Array,
      icon: String,
      countType: String,
      orglist: {
        // 人员列表
        type: Array,
        default: []
      },
      type: "", //数据筛选
    },
    data() {
      //这里存放数据
      return {
        page: 1,
        rows: 10,
        //orglist:[],//选择行政区域类型
        sourceType: [
          {
            id: null,
            label: '全部',
            isSelect: true,
          }, {
            id: 8,
            label: '事件',
            isSelect: false,
          }, {
            id: 6,
            label: '活动',
            isSelect: false,
          }, {
            id: -1,
            label: '其他',
            isSelect: false,
          },
        ],//积分来源
        sourceName: '全部',
        usertype: [{
          id: "mst,xfej,work_party",
          label: "全部",
          isSelect: true
        }, {
          id: "mst",
          label: "居民",
          isSelect: false
        }, {
          id: "xfej",
          label: "党员",
          isSelect: false
        }, {
          id: 'work_party',
          label: '在职党员',
          isSelect: false
        }
        ], //选择用户类型
        showname: ["", "", "全部"], //选择数据
        showSIndex: 0,
        comeType: "",
        showIndex: [0, 0, 0], //
        tableData: [],
        isOpen: [false, false, false], //选择器是否打开
        isSOpen: false,//积分来源选择
        dateRange: "", //选择日期
        tempDate: "",
        total: 0, //数据总数
        orderField: "", //排序内容
        orderSeq: "DESC", //排序顺序
        height: 0,
        tempDate: "",
        current: 1,
        //type: "", //数据筛选
        order: "DESC"
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      orglist(newVal, oldVal) {
        newVal.forEach((item, index) => {
          if (item.communityId == this.$store.state.streetorcommunityid) {
            this.showname[0] = item.communityName;
            this.showIndex[0] = index;
            this.getUserStatics();
          }
        });
      },
      type(newVal, oldVal) {
        console.log('------type-----------')
        console.log(newVal)
        console.log(oldVal)
      }
    },
    //方法集合
    methods: {
      /**click Page */
      clickPage(e) {
        this.page = e;
        this.getUserStatics();
      },
      clickDrop(val) {
        // console.log(val)
      },
      dropItemClickS(val) {
        // console.log(val)
        this.sourceType.forEach((item, index) => {
          item.isSelect = false
          if (index == val) {
            this.sourceType[index].isSelect = true
            this.showSIndex = index
            this.sourceName = this.sourceType[index].label
            this.comeType = this.sourceType[index].id
          }
        })
        console.log(this.comeType)
        this.getUserStatics()
      },
      /**处理index */
      formatIndex(index) {
        if (this.page == 1 && index < 9) {
          return "0" + (index + 1);
        } else {
          return this.rows * (this.page - 1) + index + 1;
        }
      },
      /**查询行政区域 */
      // getOrgAll(){
      //     console.log('cimmunityId:'+this.$store.state.streetorcommunityid)
      //     let url = this.urlobj.getOrgAll;
      //     this.$get(url, {})
      //         .then(res => {
      //             this.orglist = res.rows.map((item,index)=>{
      //                 if(item.communityId == this.$store.state.streetorcommunityid){
      //                     this.showname[0] = item.communityName
      //                     this.showIndex[0] = index
      //                 }
      //                 return {
      //                     communityId:item.communityId,
      //                     communityName:item.communityName,
      //                     isSelect: item.communityId == this.$store.state.streetorcommunityid?true:false,
      //                 }
      //             })

      //             this.getUserStatics()
      //         })
      //         .catch(e=>{

      //         })
      // },
      getUserStatics(key, order) {
        // console.log(key, order)
        let communityId = this.orglist[this.showIndex[0]].communityId;
        let appType = this.usertype[this.showIndex[2]].id;
        let countType = this.countType;
        let url = this.urlobj.getUserStatics(communityId, countType);
        let data = {
          beginTime: this.dateRange.split("到")[0],
          endTime: this.dateRange.split("到")[1],
          comeType: this.comeType,
          pageNum: this.page,
          pageSize: this.rows,
          appType,
        };
        console.log('--------getUserStatics----------')
        console.log(this.type)
        if (this.type) {
          data.orderField = this.type;
          data.orderSeq = this.order;
        }

        this.$get(url, data)
          .then(res => {
            this.total = parseInt(res.total);
            this.tableData = res.rows.map((item, index) => {
              return {
                userName: item.userName,
                userAttr: item.userAttr,
                score: item.score / 100,
                index: this.formatIndex(index),
                applyCount: item.applyCount ? item.applyCount : 0,
                signCount: item.signCount ? item.signCount : 0,
                executeCount: item.executeCount ? item.executeCount : 0,
                reportCount: item.reportCount ? item.reportCount : 0
              };
            });
            console.log(res.rows);
          })
          .catch(e => {
          });
      },
      dropDownOpen(indexval) {
        let isOpen = this.isOpen.map((item, index) => {
          return index == indexval ? !item : false;
        });
        console.log(isOpen);
        this.isOpen = isOpen;
      },
      dropItemClick(dataindex, itemIndex) {
        if (dataindex == 0) {
          this.orglist.forEach((item, index) => {
            if (itemIndex == index) {
              item.isSelect = true;
              this.showname[dataindex] = item.communityName;
              this.showIndex[dataindex] = index;
            } else {
              item.isSelect = false;
            }
          });
        } else {
          this.usertype.forEach((item, index) => {
            if (itemIndex == index) {
              item.isSelect = true;
              this.showname[dataindex] = item.label;
              this.showIndex[dataindex] = index;
            } else {
              item.isSelect = false;
            }
          });
        }
        this.isOpen[dataindex] = false;
        this.current = 1;
        this.page = 1;
        this.getUserStatics();
      },
      /**表格标题栏过去 */
      filterRemote(type, order, itemindex) {
        this.current = 1; //从第一页展示
        this.page = 1; //数据从第一页加载

        this.type = type; //数据筛选
        this.order = order; //数据筛选
        this.getUserStatics(type, order);
        this.orderField = type;
        this.orderSeq = order;
        let doms = this.$refs.userCard.getElementsByClassName(
          "ivu-icon ivu-icon-ios-funnel"
        );

        for (var i = 0; i < doms.length; i++) {
          console.log(doms[i]);
          if (i == itemindex) {
            doms[i].classList.add("on");
          } else {
            doms[i].classList.remove("on");
          }
        }
      },
      filterChange(e) {
        console.log("-------filterChange-------");
        console.log(e);
      },
      /* 时间选择 */
      dateChange(timeArr) {
        if (!timeArr[0] && !timeArr[1]) return;
        this.tempDate = timeArr.join(["到"]);
      },
      /**清空 */
      dateInit() {
        this.tempDate = "";
      },
      /* 时间选择确认 */
      dateOk() {
        /* 1. 关闭现在的时间选择器 */
        this.isOpen = [false, false, false];
        if (!this.tempDate) return;

        this.dateRange = this.tempDate;
        this.tempDate = "";
        this.getUserStatics();
      },
      /**下载数据 */
      downloadFile() {
        let communityId = this.orglist[this.showIndex[0]].communityId;
        let appType = this.usertype[this.showIndex[2]].id;
        let countType = this.countType;

        let url = this.urlobj.downloadUserStatics(
          communityId,
          countType
        );
        url +=
          "?beginTime=" + this.dateRange.split("到")[0] +
          "&endTime=" + this.dateRange.split("到")[1] +
          "&orderField=" + (this.orderField ? this.orderField : this.type) +
          "&orderSeq=" + this.orderSeq +
          "&comeType=" + this.comeType +
          '&appType=' + appType

        window.open(url);
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      //this.getOrgAll()
      //初始化行政区域
      this.showname[0] = this.$store.state.streetorcommunityname;
      //初始化时间
      let date = new Date();
      //this.initdate = this.$util.FormatDate(new Date(date.getTime() - 144*60*60*1000),"yyyy-MM-dd")+'到'+this.$util.FormatDate(new Date(),"yyyy-MM-dd")
      this.dateRange =
        //   this.$util.FormatDate(
        //     new Date(date.getTime() - 144 * 60 * 60 * 1000),
        //     "yyyy-MM-dd"
        //   ) +
        "2019-01-01" +
        "到" +
        this.$util.FormatDate(new Date(), "yyyy-MM-dd");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.height = this.$refs.userCard.offsetHeight - 122; //去掉标题和筛选
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .tr_title {
    padding: 20px;
    font-size: 16px;
    color: #333;
    line-height: 20px;
    span {
      margin-right: 10px;
    }
  }

  .icontext span {
    font-size: 14px;
    color: #67799d;
    line-height: 20px;
  }

  .icontext span:first-child {
    font-size: 20px;
    margin-right: 4px;
  }

  .tr_select {
    margin: 0 20px 20px 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    font-size: 14px;
    background-color: #fff5f3;
    padding: 0 20px;
    justify-content: space-between;
    .icon {
      color: #999;
      font-size: 10px;
      margin-left: 5px;
    }
    .icondown {
      transform: rotate(180deg);
    }
    .iconup {
      transform: rotate(0deg);
    }
  }

  .select {
    color: #ff7544;
  }

  .dropdownitem {
    height: 54px;
    line-height: 54px;
    cursor: pointer;
    &.itemselect {
      border-left: 2px solid #ff7745;
    }
    &.minWidth {
      min-width: 80px;
    }
  }

  .borderBottom {
    border-bottom: 1px solid #eeeeee;
  }

  .DropdownMenulist {
    max-height: 300px;
    overflow-y: scroll;
  }

  /*滚动条*/
  ::-webkit-scrollbar {
    width: 3px;
    height: 62px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #e2e2e2;
  }

  .icon-duigou {
    margin-left: 20px;
  }

  .footer {
    text-align: center;
  }
</style>
<style scoped>
  /*表格*/
  .ceshiclass >>> .ivu-date-picker .date-range {
    line-height: 40px !important;
  }

  .ceshiclass >>> .ivu-table-wrapper {
    border: 0 !important;
  }

  .ceshiclass >>> th {
    background-color: #fff !important;
    color: #333;
    font-size: 16px !important;
    border-bottom: 0px !important;
  }

  .ceshiclass >>> td {
    border-bottom: 0px !important;
    font-size: 16px !important;
  }

  /* .ceshiclass >>> th:first-child{
      padding-left: 20px;
  } */
  .ceshiclass >>> .ivu-table:after {
    width: 0 !important;
  }

  .ceshiclass >>> .ivu-table:before {
    height: 0 !important;
  }

  .ceshiclass >>> tbody tr:hover {
    color: #ff7743;
  }

  /*定义滚动条高宽及背景*/
  /* .ceshiclass >>>::-webkit-scrollbar{
      width: 3px !important;
    height: 62px !important;
  } */

  /*.ceshiclass >>>::-webkit-scrollbar-thumb{
      border-radius: 3px !important;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3) !important;
    background-color: #e2e2e2 !important;
  } */
  /*定义滚动条*/
  .shrink {
    flex-shrink: 0;
  }
</style>
